import { useAppStore } from '@/store/useAppStore';
import { getUnacceptedContentPolicy, isEverythingSetup } from '@/utils/onboardingUtils';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_onboarding')({
  validateSearch: (search: { linkBack?: string }) => {
    // Validate search params here. We only want valid url as link param
    if (search.linkBack) {
      return {
        linkBack: search?.linkBack as string,
      };
    }

    delete search.linkBack;
    return {};
  },
  beforeLoad: async ({ context, search }) => {
    const isOrgAdmin = context.auth?.isAdmin;
    const isSuperAdmin = context.auth?.isSuperAdmin;
    const isContentCreator = context.auth?.isContentCreator;
    const isContentCreatorOnly = context.auth?.isContentCreator && context.auth?.user?.roles.length === 1;

    if (isSuperAdmin) {
      throw redirect({
        to: '/organization/dashboard',
      });
    }

    const { onboardingStatuses, hasUnacceptedLegalDocuments, legalAcceptanceStatuses } = useAppStore.getState();

    const isOnboardingCompleted = isEverythingSetup(onboardingStatuses, isOrgAdmin, isContentCreatorOnly);

    if (isOnboardingCompleted) {
      const { isUserOnboardingCompleted, isOrganizationOnboardingCompleted } = onboardingStatuses;

      if (isOrgAdmin && !isOrganizationOnboardingCompleted) {
        throw redirect({
          to: '/organization/dashboard',
        });
      }

      if (isUserOnboardingCompleted || isContentCreatorOnly) {
        if (hasUnacceptedLegalDocuments) {
          if (isContentCreator && getUnacceptedContentPolicy(legalAcceptanceStatuses)) {
            throw redirect({
              to: '/creator/apply/content-policy',
            });
          }

          throw redirect({
            to: '/eula/update',
          });
        }

        throw redirect({
          to: search.linkBack ? search.linkBack : isContentCreatorOnly ? '/creator/dashboard' : '/user/dashboard',
        });
      }

      throw redirect({
        to: '/eula/update',
      });
    }
  },
});
